import { useMutation } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useDeleteTriggerMutation = (onError: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (triggerGuid: string) => {
            const response = await zoneApiClient.deleteTrigger(triggerGuid);

            if (!response?.httpResponse.ok) {
                if (response.httpResponse.status === 400) {
                    throw new Error(`Failed to delete Trigger : ${response.errorMessage}`);
                } else if (response.httpResponse.status === 403) {
                    throw new Error(`Forbidden to delete trigger`);
                }

                throw new Error('Failed to delete Trigger');
            }

            return true;
        },
        onError(error) {
            if (error instanceof Error) {
                onError(error.message);
            }
        },
    });

}
